import { render } from "./LoaderComp.vue?vue&type=template&id=52d08e02&scoped=true"
import script from "./LoaderComp.vue?vue&type=script&lang=js"
export * from "./LoaderComp.vue?vue&type=script&lang=js"

import "./LoaderComp.vue?vue&type=style&index=0&id=52d08e02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d08e02"]])

export default __exports__